class SMHistoryHelper {
  
  static pushState(url, obj){
    if (this.canPushState) {
      window.history.pushState(obj, '', url);
    }
  }
  
  static replaceState(url, obj){
    if (this.canPushState) {
      window.history.replaceState(obj, '', url);
    }
  }
  
  static canPushState(){
    return (window.history && window.history.pushState);
  }
  
  static observePopState(callback){
    if (this.canPushState()) {
      $(window).on("popstate", function(e){
        const state = e.originalEvent.state;
        if (state) callback(state);
      });
    }
  }
  
}
export default SMHistoryHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMHistoryHelper.js